import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { catchError, finalize, switchMap, take, tap } from 'rxjs';
import { DisplayScanApiService } from './display-scan.api.service';

@Component({
	selector: 'app-display-scan',
	standalone: true,
	imports: [MatProgressSpinner],
	providers: [DisplayScanApiService],
	templateUrl: './display-scan.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayScanComponent implements OnInit {
	readonly loading = signal(true);
	readonly imageSrc = signal(null);

	private readonly displayScanApiService = inject(DisplayScanApiService);
	private readonly activatedRoute = inject(ActivatedRoute);

	ngOnInit(): void {
		this.activatedRoute.params
			.pipe(
				take(1),
				switchMap((params) =>
					this.displayScanApiService.getScan(params.id).pipe(
						tap((value) => {
							this.createImageFromBlob(value);
						}),
						finalize(() => this.loading.set(false)),
					),
				),
			)
			.subscribe();
	}

	private createImageFromBlob(blob: Blob) {
		const reader = new FileReader();
		reader.onload = (event: ProgressEvent<FileReader>) => {
			this.imageSrc.set(event.target.result);
		};
		reader.readAsDataURL(blob);
	}
}
